import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b303d32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address-title" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "valid-email"
}
const _hoisted_6 = {
  key: 0,
  class: "defaultChecked"
}
const _hoisted_7 = { class: "address-form" }
const _hoisted_8 = { class: "form-title" }
const _hoisted_9 = { class: "form-title" }
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = { class: "dialog-footer" }

import { t } from '@/plugins/i18n'
import { reactive, ref, computed, watch } from 'vue'
import { zhjaReg, isdeepsame, isContractName } from '@/plugins/utils'
import type { FormInstance } from 'element-plus'
import countryCodes from '@/views/signup/components/countryCodes'
import STable from '@/components/Table/index.vue'
import AddrForm from '@/views/setup/components/AddrForm.vue'
import { useStore } from 'vuex'
import { getInternationalAreaTxt, getInternationalCityTxt } from './data'
import { Jp2En } from '@/apis/address'
import { ElMessage } from 'element-plus'
import useRules, { useMust } from '@/util/useRules'
import {
  addTakeAddr,
  addClearAddr,
  updateClearAddr
} from '@/apis/setup'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  config: {
    type: Object,
    default: () => ({})
  },
  addApi: {
    type: Function
  },
  setDefaultApi: {
    type: Function
  },
  provinces: {
    type: Array,
    default: () => []
  },
  selectAddress: {
    type: Object,
    default: () => ({})
  },
  wareType: {
    type: String,
    default: 'CN'
  }
},
  emits: ['update:visible', 'refresh', 'select'],
  setup(__props, { emit: emits }) {

const props = __props

const addVisible = ref(false)


const hasObjProp = (key: any) => Object.prototype.hasOwnProperty.call(form, key)

const selectAddressId = ref(props.selectAddress[props.config.id])
watch(() => props.selectAddress, (newValue) => {
  selectAddressId.value = newValue[props.config.id]
})
const setDefaultAddress = (row: any) => {
  console.log(row)
  selectAddressId.value = row[props.config.id]
}

const form: any = reactive({ ...props.config.defaultForm, isCreate: true })
const defaultForm = JSON.parse(JSON.stringify(props.config.defaultForm))

const setJp2En = (text: any) => {
  return new Promise((resolve) => {
    Jp2En({ text }).then(res => {
      resolve(res.data)
    })
  })
}

const setArea = async () => {
  form.city = ''
  const area: any = props.provinces.find((e: any) => e.intAreaId === form.area)
  form.areaEn = await setJp2En(area.label)
}

const setCity = async () => {
  const city: any = cities.value.find((e: { intAreaId: any }) => e.intAreaId === form.city)
  form.cityEn = await setJp2En(city.label)
}
const setAddress = async () => {
  form.addressEn = await setJp2En(form.address)
}

watch(
  form,
  () => {
    store.commit('status/editing', !isdeepsame(defaultForm, form))
  },
  { deep: true }
)

const addressValidator = (rule: any, val: string, callback: any) => {
  const regx = /^[\da-zA-Z\s`~!@#$%^&*|,.()_\-+=<>?:\\"{}\\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’ ''，。、]{3,100}$/
  if (val && !(regx).test(val)) {
    callback(t('仅限输入英文和数字字符'))
  } else {
    callback()
  }
}

const isJapan = (val: any): boolean => /[\u3040-\u309F\u30A0-\u30FF]/.test(val)

const rules = {
  receiveName: useRules({ message: t('收件人姓名不能为空'), key: 'deliver' }),
  companyName: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!val) return callback()
        if (new RegExp(`^[${zhjaReg}a-zA-Z]{0,}$`).test(val)) {
          callback()
        } else {
          callback(t('无效内容'))
        }
      },
      trigger: 'blur'
    }
  ],
  phone: useRules({ message: t('联系电话不能为空'), key: 'phone' }),
  area: useMust(t('都道府县不能为空'), 'change'),
  city: useMust(t('市不能为空'), 'change'),
  address: useRules({ message: t('详细地址不能为空'), key: 'address' }),
  receiveNameEn: useRules({ message: t('收件人姓名不能为空'), key: 'plainEn' }),
  companyNameEn: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!val) return callback()
        if (/^[a-zA-Z\s]+$/.test(val.trim())) {
          callback()
        } else {
          callback(t('仅限输入英文字符'))
        }
      },
      trigger: 'blur'
    }
  ],
  areaEn: [
    { required: true, message: t('都道府县不能为空') },
    {
      validator: addressValidator,
      trigger: 'blur'
    }
  ],
  cityEn: [
    { required: true, message: t('市不能为空') },
    {
      validator: addressValidator,
      trigger: 'blur'
    }
  ],
  addressEn: [
    { required: true, message: t('市不能为空') },
    {
      validator: addressValidator,
      trigger: 'blur'
    }
  ],
  postalCode: useRules({ message: t('邮编不能为空'), key: 'postal' })
}

const defaultAddress = computed({
  get: () => !!form.defaultAddress,
  set: (v) => { form.defaultAddress = v ? 1 : 0 }
})

const confirmAddress = () => {
  emits('select', selectAddressId.value)
  emits('update:visible', false)
}

const clear = () => {
  Object.entries(defaultForm).forEach(([k, v]) => {
    form[k] = JSON.parse(JSON.stringify(v))
  })
  store.commit('status/editing', false)
}

const showForm = ref(false)
watch(() => [props.visible, props.config?.list], (newValue) => {
  if (newValue) {
    showForm.value = !(props.config?.list.length > 0)
  }
})
const hasList = computed(() => {
  return props.config?.list.length > 0
})
const cities: any = ref([])

const cancel = () => {
  clear()
  showForm.value = false
  emits('update:visible', false)
}
const store = useStore()
const closeExitAddress = (done: () => void) => {
  if (showForm.value) {
    cancel()
  } else {
    done()
  }
}

const addAddressLoading = ref(false)
const formRef = ref<FormInstance>()
const addAddress = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  formEl.validate((valid) => {
    if (valid && props.addApi) {
      addAddressLoading.value = true
      props.addApi(form).then((res: any) => {
        if (res.success) {
          ElMessage.success(t('地址添加成功'))
          emits('refresh')
          addAddressLoading.value = false
          showForm.value = false
        } else {
          addAddressLoading.value = false
        }
      }).catch(() => { addAddressLoading.value = false })
    } else {
      return false
    }
  })
}

const item = ref({})
const name = ref(props.config.id === 'shopShippingAddressId' ? 'take' : 'clear')
const openAddressModal = (row?: any) => {
  addVisible.value = true
  item.value = {
    ...row,
    isCreate: !row
  }
}

const addApi = (data: any) =>
  props.config.id === 'shopShippingAddressId' ? addTakeAddr(data) : addClearAddr(data)
const update = (item: any) => {
  const { shopShippingAddressId, shopClearanceAddressId } = item
  let api = addApi
  if (shopShippingAddressId || shopClearanceAddressId) {
    api = updateClearAddr
  }
  if (!item.address) {
    item.address = item.addressEn
  }
  return api({
    ...item,
    defaultAddress: item.defaultAddress ? 1 : 0
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t(api === addApi ? t('添加成功') : t('修改成功')))
      emits('refresh')
    }
    return res.success
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      "model-value": __props.visible,
      "before-close": (done) => closeExitAddress(done),
      onClose: _cache[18] || (_cache[18] = ($event: any) => (emits('update:visible', false)))
    }, {
      footer: _withCtx(() => [
        _withDirectives(_createElementVNode("span", _hoisted_10, [
          _createVNode(_component_el_button, { onClick: cancel }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: addAddressLoading.value,
            onClick: openAddressModal
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('添加地址')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ], 512), [
          [_vShow, showForm.value]
        ]),
        _withDirectives(_createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: _cache[17] || (_cache[17] = ($event: any) => (emits('update:visible', false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmAddress
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, !showForm.value]
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(__props.config.title || _unref(t)('选择地址')), 1),
        _withDirectives(_createVNode(STable, {
          ref: (_value, _refs) => {
            _refs['STableRef'] = _value
          },
          class: _normalizeClass({ hideHeader: showForm.value }),
          style: {"margin-bottom":"6px"},
          "table-data": __props.config.list,
          columns: __props.config.columns,
          showPagination: false
        }, {
          countryName: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.countryName || '日本'), 1)
          ]),
          checked: _withCtx(({ row }) => [
            _createVNode(_component_el_radio, {
              modelValue: selectAddressId.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectAddressId).value = $event)),
              label: row[__props.config.id],
              onChange: ($event: any) => (setDefaultAddress(row))
            }, null, 8, ["modelValue", "label", "onChange"])
          ]),
          company: _withCtx(({ row }) => [
            (row.companyName)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(row.companyName), 1))
              : _createCommentVNode("", true),
            (row.companyCode)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, "(" + _toDisplayString(row.companyCode) + ")", 1))
              : _createCommentVNode("", true)
          ]),
          area: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.provinceName), 1)
          ]),
          city: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.cityName), 1)
          ]),
          email: _withCtx(({ row }) => [
            (row.email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(row.email), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(t)('请填写邮箱')), 1))
          ]),
          postalCode: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.postalCode) + " ", 1),
            (!!row.defaultAddress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(t)('默认')), 1))
              : _createCommentVNode("", true)
          ]),
          action: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "text",
              size: "small",
              onClick: ($event: any) => (openAddressModal(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('编辑')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["class", "table-data", "columns"]), [
          [_vShow, _unref(hasList)]
        ]),
        _createElementVNode("a", {
          style: {"display":"block","margin":"20px","text-align":"right"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (openAddressModal()))
        }, _toDisplayString(_unref(t)('添加新地址')), 1),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          false
            ? (_openBlock(), _createBlock(_component_el_form, {
                key: 0,
                ref: (_value, _refs) => {
                  _refs['formRef'] = _value
                  formRef.value = _value
                },
                model: _unref(form),
                rules: rules,
                "label-width": 140
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('日文收货地址')), 1),
                  (hasObjProp('receiveName'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: _unref(t)('姓名'),
                        prop: "receiveName"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(form).receiveName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).receiveName) = $event)),
                            style: {"width":"200px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (hasObjProp('companyName'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: _unref(t)('公司名'),
                        prop: "companyName"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(form).companyName,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).companyName) = $event)),
                            style: {"width":"376px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (hasObjProp('companyCode'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 2,
                        label: _unref(t)('会社编号')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(form).companyCode,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).companyCode) = $event)),
                            style: {"width":"376px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (hasObjProp('phone'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 3,
                        label: _unref(t)('联系电话'),
                        prop: "phone"
                      }, {
                        default: _withCtx(() => [
                          (hasObjProp('country'))
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 0,
                                modelValue: _unref(form).country,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).country) = $event)),
                                class: "receive-country"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countryCodes), (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item,
                                      label: item,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                          (hasObjProp('phone'))
                            ? (_openBlock(), _createBlock(_component_el_input, {
                                key: 1,
                                modelValue: _unref(form).phone,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).phone) = $event)),
                                style: {"width":"200px"}
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (hasObjProp('area'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 4,
                        label: _unref(t)('都道府县'),
                        prop: "area"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(form).area,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).area) = $event)),
                            style: {"width":"376px"},
                            onChange: setArea
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.provinces as any), (v) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: v.intAreaId,
                                  value: v.intAreaId,
                                  label: v.label,
                                  onClick: ($event: any) => (cities.value = v.children)
                                }, null, 8, ["value", "label", "onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (hasObjProp('city'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 5,
                        label: _unref(t)('市'),
                        prop: "city"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            placeholder: " ",
                            modelValue: _unref(form).city,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).city) = $event)),
                            class: "receive-city",
                            onChange: setCity
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                value: undefined,
                                label: "-"
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cities.value, (v) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: v.intAreaId,
                                  value: v.intAreaId,
                                  label: v.label
                                }, null, 8, ["value", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (hasObjProp('address'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 6,
                        label: _unref(t)('详细地址'),
                        prop: "address"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            autosize: { minRows: 2, maxRows: 4 },
                            style: {"width":"620px"},
                            modelValue: _unref(form).address,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).address) = $event)),
                            maxlength: 100,
                            placeholder: _unref(t)('请输入详细地址'),
                            onInput: setAddress
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (hasObjProp('postalCode'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 7,
                        label: _unref(t)('邮编'),
                        prop: "postalCode"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(form).postalCode,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).postalCode) = $event)),
                            style: {"width":"376px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('英文收货地址')), 1),
                  (hasObjProp('receiveNameEn'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 8,
                        label: _unref(t)('姓名'),
                        prop: "receiveNameEn"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(form).receiveNameEn,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).receiveNameEn) = $event)),
                            style: {"width":"200px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (hasObjProp('companyNameEn'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 9,
                        label: _unref(t)('公司名'),
                        prop: "companyNameEn"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(form).companyNameEn,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).companyNameEn) = $event)),
                            style: {"width":"376px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (hasObjProp('areaEn'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 10,
                        label: _unref(t)('都道府县'),
                        prop: "areaEn"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(form).areaEn,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(form).areaEn) = $event)),
                            style: {"width":"200px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (hasObjProp('cityEn'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 11,
                        label: _unref(t)('市'),
                        prop: "cityEn"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(form).cityEn,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(form).cityEn) = $event)),
                            style: {"width":"200px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (hasObjProp('addressEn'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 12,
                        label: _unref(t)('详细地址'),
                        prop: "addressEn"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            autosize: { minRows: 2, maxRows: 4 },
                            style: {"width":"620px"},
                            modelValue: _unref(form).addressEn,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(form).addressEn) = $event)),
                            maxlength: 100,
                            placeholder: _unref(t)('请输入详细地址')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      (hasObjProp('defaultAddress'))
                        ? (_openBlock(), _createBlock(_component_el_checkbox, {
                            key: 0,
                            modelValue: _unref(defaultAddress),
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(defaultAddress) ? (defaultAddress).value = $event : null)),
                            label: _unref(t)('设为默认地址'),
                            size: "small"
                          }, null, 8, ["modelValue", "label"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, showForm.value]
        ])
      ]),
      _: 1
    }, 8, ["model-value", "before-close"]),
    (addVisible.value)
      ? (_openBlock(), _createBlock(AddrForm, {
          key: 0,
          visible: addVisible.value,
          "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((addVisible).value = $event)),
          data: item.value,
          "onUpdate:data": _cache[20] || (_cache[20] = ($event: any) => ((item).value = $event)),
          name: name.value,
          update: update,
          defaultCountryCode: __props.wareType
        }, null, 8, ["visible", "data", "name", "defaultCountryCode"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})